import TimeAgo from "javascript-time-ago";
import moment from 'moment';

// English.
import en from "javascript-time-ago/locale/en";
import es from 'javascript-time-ago/locale/es'

TimeAgo.addLocale(en);
TimeAgo.addDefaultLocale(es);
// Create formatter (English).
const timeAgo = new TimeAgo("en-US");
//const timeAgo = new TimeAgo("es-MX");

export class TimeUtil {

   /***
   * convert to the local timezone
   */
  public static ago(date: Date) {
    return timeAgo.format(date);
  }

  public static formatDate = (date)=>{
    /*if(date){
      //let nd = new Date(Date.parse(date));
      //return `${nd.getFullYear()}-${nd.getMonth()+1}-${nd.getDate()}`;
      return moment.utc(date).local().format("YYYY-MM-DD");
      //return "";
    }else{
      return "";
    }*/
   return TimeUtil.formatDateWithFormat(date,"YYYY-MM-DD");
  }

  public static formatDateWithFormat = (date,format)=>{
    if(date){
      //let nd = new Date(Date.parse(date));
      //return `${nd.getFullYear()}-${nd.getMonth()+1}-${nd.getDate()}`;
      return moment.utc(date).local().format(format);
      //return "";
    }else{
      return "";
    }
  }

  public static formatAgo = (dateString) => {
    let ds = moment.utc(dateString).local(true).toString();
    const date = new Date(ds);
    var newDate = new Date(date);
    newDate.setMinutes(date.getMinutes() - date.getTimezoneOffset());    
    return TimeUtil.ago(newDate);
  }
}
